// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__WOc2r","alertIcon":"ConfirmModal_alertIcon__3qSrM"};